import type { IconName } from '@/ui';

export interface NavItem {
  id: string;
  label: string;
  icon: IconName;
  path: string;
  // Only visible to actual admins (by user role, not the "viewing as" persona).
  adminOnly?: boolean;
}

export const NAV: NavItem[] = [
  { id: 'home', label: 'Home', icon: 'home', path: '/' },
  { id: 'portfolio', label: 'Portfolio', icon: 'portfolio', path: '/portfolio' },
  { id: 'initiatives', label: 'Initiatives', icon: 'initiatives', path: '/initiatives' },
  { id: 'projects', label: 'Projects', icon: 'projects', path: '/projects' },
  { id: 'ideas', label: 'Ideas', icon: 'ideas', path: '/ideas' },
  { id: 'components', label: 'Components', icon: 'components', path: '/components' },
  { id: 'tickets', label: 'Tickets', icon: 'tickets', path: '/tickets' },
  { id: 'releases', label: 'Releases', icon: 'branch', path: '/releases' },
  { id: 'messages', label: 'Messages', icon: 'bell', path: '/messages' },
  { id: 'help', label: 'Help Board', icon: 'help', path: '/help' },
  { id: 'admin', label: 'Admin', icon: 'admin', path: '/admin', adminOnly: true },
];

// Focus mode: every nav item still shows, but only these ids are clickable.
// The rest render grayed-out and non-navigable so the surface area stays
// visible without being usable yet. Set to null to enable all.
const ENABLED_NAV_IDS: string[] | null = ['home', 'projects', 'ideas', 'admin'];

export function isNavEnabled(id: string): boolean {
  return !ENABLED_NAV_IDS || ENABLED_NAV_IDS.includes(id);
}

export function visibleNav(isAdmin: boolean): NavItem[] {
  return NAV.filter((n) => !n.adminOnly || isAdmin);
}
